import React from 'react';
import { Tabs as BSTabs} from "react-bootstrap";
import { useDirtyWarningContext, DirtyWarningConfirmProps } from '../DirtyWarning/DirtyWarningContext';

export interface SelectTabCallback extends React.EventHandler<any> {
    (eventKey: any, e: React.SyntheticEvent<{}>): void;
    /**
     * @deprecated
     * This signature is a hack so can still derive from HTMLProps.
     * It does not reflect the underlying event and should not be used.
     */
    (e: React.MouseEvent<{}>): void;
}

export interface TabsProps extends React.HTMLProps<any>, DirtyWarningConfirmProps {
    activeKey?: any;
    animation?: boolean;    
    defaultActiveKey?: any;
    onSelect?: SelectTabCallback;
    paneWidth?: any;
    position?: string;
    tabWidth?: any;
    mountOnEnter?: boolean;
    unmountOnExit?: boolean;
    justified?: boolean;
}

export const Tabs: React.FC<TabsProps> = (props) => {
    const context = useDirtyWarningContext();   
    const { onSelect, dirtyWarningMessage, resetDirtyTracking = false, showDirtyWarning = false, ...otherProps } = props;

    const handleSelect = async (eventKey: any) => {
        const proceed = !showDirtyWarning || !context.dirty || await context.confirm(dirtyWarningMessage);        
        if (proceed) {
            if (onSelect) onSelect(eventKey);
            if (resetDirtyTracking) context.setDirty(false);
        }       
    }

    return (
        <BSTabs onSelect={handleSelect} {...otherProps}>
            {props.children}
        </BSTabs>
    )
}

(Tabs as any).displayName = 'Tabs';